export const APPLY_VENDOR_COUPON = 'APPLY_VENDOR_COUPON';
export const APPLY_VENDOR_COUPON_ERROR = 'APPLY_VENDOR_COUPON_ERROR';
